import React, { useState, useEffect } from 'react';
import DataTable from '../DataTable';
import { getPackages, getProcessedDocuments } from '../../utils/api';
import { useDocument } from '../../utils/DocumentContext';
import WindowProducts from '../Windows/WindowProducts';
import WindowPrint from '../Windows/WindowPrint';

export default function AllDocumentsSection() {
  const [documentsData, setDocumentsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showProductsWindow, setShowProductsWindow] = useState(false);
  const [selectedDocumentForProducts, setSelectedDocumentForProducts] = useState(null);  // Стан для вікна друку
  const [showPrintWindow, setShowPrintWindow] = useState(false);
  const [printDocument, setPrintDocument] = useState(null);
  const [printPositions, setPrintPositions] = useState([]);
  // Стан для оброблених документів
  const [processedDocuments, setProcessedDocuments] = useState([]);

  const { selectedDocument, selectDocument, clearDocument } = useDocument();

  useEffect(() => {
    fetchDocumentsData();
  }, []);
  const fetchDocumentsData = async () => {
    try {
      setLoading(true);      setError('');
      // Завантажуємо основні пакети та оброблені документи паралельно
      const [packagesResponse, processedResponse] = await Promise.all([
        getPackages(),
        getProcessedDocuments()
      ]);

      // Зберігаємо список оброблених документів
      let processedDocsList = [];
      if (processedResponse.success && processedResponse.documents) {
        processedDocsList = processedResponse.documents;
        setProcessedDocuments(processedDocsList);
      }

      if (packagesResponse.success && packagesResponse.packages) {
        const allDocuments = [];packagesResponse.packages.forEach(pkg => {
          if (pkg.Документы && Array.isArray(pkg.Документы)) {
            pkg.Документы.forEach(doc => {              const documentId = `${pkg.ИдентификаторПакета}_${doc.ДокументНомер}`;
              // Перевіряємо, чи є цей документ в оброблених
              const processedDoc = processedDocsList.find(processedDoc =>
                processedDoc.ДокументНомер === doc.ДокументНомер
              );
              const isProcessed = !!processedDoc;

              let totalPlan = 0;
              let totalFact = 0;
              let positionsCount = 0;              if (isProcessed && processedDoc.Позиции) {
                // Якщо документ оброблений, використовуємо дані з обробленого документа
                processedDoc.Позиции.forEach(pos => {
                  totalPlan += Number(pos.КоличествоПлан) || 0;
                  totalFact += Number(pos.КоличествоФакт) || 0;
                });
                positionsCount = processedDoc.Позиции.length;
              } else if (doc.Позиции && Array.isArray(doc.Позиции)) {
                // Якщо документ не оброблений, використовуємо вихідні дані
                doc.Позиции.forEach(pos => {
                  totalPlan += Number(pos.КоличествоПлан) || 0;
                  totalFact += Number(pos.КоличествоФакт) || 0;
                });
                positionsCount = doc.Позиции.length;
              }

              allDocuments.push({
                id: documentId,
                documentType: doc.ДокументВид || 'Не вказано',
                documentNumber: doc.ДокументНомер,
                documentDate: formatDate(doc.ДокументДата),
                packageId: pkg.ИдентификаторПакета,
                packageDate: formatDate(pkg.ДатаФормирования),
                totalPlan,
                totalFact,
                positionsCount,
                status: isProcessed ? 'Оброблено' : (doc.ДокументСтатус || 'Новий'),
                rawDocument: doc,
                rawPackage: pkg,
                processedDocument: processedDoc // Зберігаємо посилання на оброблений документ
              });
            });
          }
        });

        setDocumentsData(allDocuments);
      } else {
        setDocumentsData([]);
      }    } catch (err) {
      console.error('Помилка завантаження всіх документів:', err);
      setError('Помилка завантаження даних: ' + (err.message || 'Невідома помилка'));
    } finally {
      setLoading(false);
    }};
  const formatDate = (dateString) => {
    if (!dateString) return 'Не вказана';
    try {
      return new Date(dateString).toLocaleString('uk-UA');
    } catch {
      return 'Неправильна дата';
    }
  };  const handleSelectDocument = (row) => {
    // Використовуємо вже визначений в row стан обробки
    const isProcessed = row.status === 'Оброблено';
    const processedDoc = row.processedDocument;

    let adaptedDocument, adaptedPositions;

    if (isProcessed && processedDoc) {
      // Якщо документ оброблений, використовуємо дані з обробленого документа
      adaptedDocument = {
        id: processedDoc.ДокументНомер,
        filename: processedDoc.ДокументНомер,
        created: processedDoc.ДокументДата,
        ДокументДата: processedDoc.ДокументДата,
        ДокументВид: processedDoc.ДокументВид,
        documentType: processedDoc.ДокументВид,
        size: JSON.stringify(processedDoc).length,
        data: processedDoc,
        isProcessed: true
      };

      adaptedPositions = (processedDoc.Позиции || []).map(pos => ({
        id: pos.Код,
        article: pos.Код,
        name: pos.Наименование,
        barcode: pos.Штрихкод || pos.Код,
        plan: Number(pos.КоличествоПлан) || 0,
        fact: Number(pos.КоличествоФакт) || 0,
        reserve: Number(pos.КоличествоРезерв) || 0,
        status: pos.СтатусПозиции || '',
        category: pos.Категория || '',
        subcategory: pos.Подкатегория || '',
        brand: pos.ТорговаяМарка || '',
        warehouse: pos.Склад || '',
        // Дублируем поля для совместимости
        Код: pos.Код,
        Наименование: pos.Наименование,
        Штрихкод: pos.Штрихкод,
        КоличествоПлан: Number(pos.КоличествоПлан) || 0,
        КоличествоФакт: Number(pos.КоличествоФакт) || 0,
        КоличествоРезерв: Number(pos.КоличествоРезерв) || 0,
        СтатусПозиции: pos.СтатусПозиции || '',
        Категория: pos.Категория || '',
        Подкатегория: pos.Подкатегория || '',
        ТорговаяМарка: pos.ТорговаяМарка || '',
        Склад: pos.Склад || ''
      }));    } else {
      // Якщо документ не оброблений, використовуємо вихідні дані
      adaptedDocument = {
        id: row.rawDocument.ДокументНомер,
        filename: row.rawDocument.ДокументНомер,
        created: row.rawDocument.ДокументДата,
        ДокументДата: row.rawDocument.ДокументДата,
        ДокументВид: row.rawDocument.ДокументВид,
        documentType: row.rawDocument.ДокументВид,
        size: JSON.stringify(row.rawDocument).length,
        data: row.rawDocument,
        isProcessed: false
      };      adaptedPositions = (row.rawDocument.Позиции || []).map(pos => ({
        id: pos.Код,
        article: pos.Код,
        name: pos.Наименование,
        barcode: pos.Штрихкод || pos.Код,
        plan: Number(pos.КоличествоПлан) || 0,
        fact: Number(pos.КоличествоФакт) || 0,
        reserve: Number(pos.КоличествоРезерв) || 0,
        status: pos.СтатусПозиции || '',
        category: pos.Категория || '',
        subcategory: pos.Подкатегория || '',
        brand: pos.ТорговаяМарка || '',
        warehouse: pos.Склад || '',
        // Дублюємо поля для сумісності
        Код: pos.Код,
        Наименование: pos.Наименование,
        Штрихкод: pos.Штрихкод,
        КоличествоПлан: Number(pos.КоличествоПлан) || 0,
        КоличествоФакт: Number(pos.КоличествоФакт) || 0,
        КоличествоРезерв: Number(pos.КоличествоРезерв) || 0,
        СтатусПозиции: pos.СтатусПозиции || '',
        Категория: pos.Категория || '',
        Подкатегория: pos.Подкатегория || '',
        ТорговаяМарка: pos.ТорговаяМарка || '',
        Склад: pos.Склад || ''
      }));
    }

    selectDocument(adaptedDocument, adaptedPositions, isProcessed);
  };

  const handleToggleDocument = (row) => {
    const selected = isDocumentSelected(row.documentNumber);
    if (selected) {
      clearDocument();
    } else {
      handleSelectDocument(row);
    }
  };

  const isDocumentSelected = (documentNumber) =>
      selectedDocument && selectedDocument.filename === documentNumber;  // Обробники для вікна товарів
  const handleRowClick = (row) => {
    const isProcessed = row.status === 'Оброблено';
    const processedDoc = row.processedDocument;
    
    let documentForProducts;
    
    if (isProcessed && processedDoc) {
      // Якщо документ оброблений, використовуємо оброблені дані
      documentForProducts = {
        ...processedDoc,
        isProcessed: true,
        // Додаємо додаткові поля для сумісності
        ДокументНомер: processedDoc.ДокументНомер,
        ДокументВид: processedDoc.ДокументВид,
        ДокументДата: processedDoc.ДокументДата
      };    } else {
      // Якщо документ не оброблений, використовуємо вихідні дані
      documentForProducts = {
        ...row.rawDocument,
        isProcessed: false
      };
    }
    
    setSelectedDocumentForProducts(documentForProducts);
    setShowProductsWindow(true);
  };

  const handleCloseProductsWindow = () => {
    setShowProductsWindow(false);
    setSelectedDocumentForProducts(null);
  };
  // Обробники для вікна друку
  const handleOpenPrint = (printData = [], documentData = null, positions = []) => {
    console.log('handleOpenPrint викликано з параметрами:', { printData, documentData, positions });
    setPrintDocument(documentData);
    setPrintPositions(positions);
    setShowPrintWindow(true);
  };

  const handleClosePrintWindow = () => {
    setShowPrintWindow(false);
    setPrintDocument(null);
    setPrintPositions([]);
  };

  const columns = [    // Колонка зі статусом (тільки індикатор)
    {
      key: 'statusIndicator',
      title: '',
      width: '50px',
      textAlign: 'center',
      render: (_, row) => {
        // Використовуємо вже обчислений статус з row
        const currentStatus = row.status || 'Новий';
        
        // Визначаємо іконку залежно від статусу
        let statusIcon;
        switch (currentStatus) {
          case 'Новий':
          case '':
            statusIcon = '🟡'; // Жовте коло
            break;
          case 'До обробки':
            statusIcon = '🔵'; // Синє коло
            break;
          case 'Оброблено':
            statusIcon = '🟢'; // Зелене коло
            break;
          default:
            statusIcon = '🟡';
        }
        
        return (
          <div
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              margin: '0 auto'
            }}
            title={`Статус: ${currentStatus}`}
          >
            {statusIcon}
          </div>
        );
      }
    },
    { key: 'documentType', title: 'Вид документа', width: '180px', sortable: true, filterable: true },
    {
      key: 'documentNumber',
      title: 'Номер документа',
      width: '150px',
      sortable: true,
      filterable: true,
      render: (value) => <span style={{ fontWeight: 500, color: '#333' }}>{value}</span>
    },    { key: 'documentDate', title: 'Дата документа', width: '140px', sortable: true },
    { key: 'packageId', title: 'Номер пакета', width: '150px', sortable: true, filterable: true },
    { key: 'packageDate', title: 'Дата пакета', width: '140px', sortable: true },
    {
      key: 'positionsCount',
      title: 'Позицій',
      width: '80px',
      sortable: true,
      textAlign: 'center',
      render: (value) => {
        return <span style={{ fontWeight: 500, color: '#666' }}>{value || 0}</span>;
      }
    },
    {
      key: 'totalPlan',
      title: 'План',
      width: '100px',
      sortable: true,
      textAlign: 'right',
      render: (value) => {
        const num = Number(value || 0);
        const str = num.toString();
        const dec = str.includes('.') ? str.split('.')[1] : '';
        const formatted = dec.length > 3 ? num.toFixed(3) : str;
        return <span style={{ fontWeight: 500 }}>{formatted}</span>;
      }
    },
    {
      key: 'totalFact',
      title: 'Факт',
      width: '100px',
      sortable: true,
      textAlign: 'right',
      render: (value) => {
        const num = Number(value || 0);
        const str = num.toString();
        const dec = str.includes('.') ? str.split('.')[1] : '';
        const formatted = dec.length > 3 ? num.toFixed(3) : str;
        return <span style={{ fontWeight: 500, color: value > 0 ? '#2e7d32' : '#666' }}>{formatted}</span>;
      }    },
    {
      key: 'action',
      title: 'Дія',
      width: '120px',
      textAlign: 'center',
      render: (_, row) => {
        const selected = isDocumentSelected(row.documentNumber);
        return (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 4 }}>
              <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleToggleDocument(row);
                  }}
                  style={{
                    padding: '4px 8px',
                    background: selected ? '#f44336' : '#4caf50',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 4,
                    cursor: 'pointer',
                    fontSize: 11,
                    fontWeight: 500
                  }}
                  title={selected ? 'Скасувати вибір' : 'Обрати як поточний документ'}
              >
                {selected ? '✖' : '✓'}
              </button>              <button
                  onClick={(e) => {
                    e.stopPropagation();                    // Використовуємо оброблений документ, якщо він є, інакше вихідний
                    const documentForPrint = row.processedDocument || row.rawDocument;
                    const positionsForPrint = documentForPrint.Позиции || [];
                    handleOpenPrint([], documentForPrint, positionsForPrint);
                  }}
                  style={{
                    padding: '4px 8px',
                    background: '#1976d2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 4,
                    cursor: 'pointer',
                    fontSize: 11,
                    fontWeight: 500
                  }}
                  title="Друк документа"
              >
                🖨️
              </button>
            </div>
        );
      }
    }
  ];

  if (loading) {
    return (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: '#666' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 16 }}>📄</div>
            <div>Завантаження документів...</div>
          </div>
        </div>
    );
  }

  if (error) {
    return (
        <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 20,
              color: '#d32f2f'
            }}
        >          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <div style={{ fontSize: 18, marginBottom: 10 }}>Помилка завантаження</div>
          <div style={{ fontSize: 14, textAlign: 'center', marginBottom: 20 }}>{error}</div>
          <button
              onClick={fetchDocumentsData}
              style={{ padding: '8px 16px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}
          >
            Повторити спробу
          </button>
        </div>
    );
  }

  const selectedRowIndex =
      selectedDocument ? documentsData.findIndex((d) => d.documentNumber === selectedDocument.filename) : null;

  return (
      <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            padding: window.innerWidth < 768 ? '8px 0' : '16px',
            boxSizing: 'border-box'
          }}
      >
        {/* Шапка секции */}
        <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: window.innerWidth < 768 ? '8px' : '16px',
              margin: window.innerWidth < 768 ? '0 8px 8px 8px' : '0 0 16px 0',
              padding: window.innerWidth < 768 ? '8px' : '12px',
              background: 'linear-gradient(135deg, #e3f2fd 0%, #2196f3 100%)',
              border: window.innerWidth < 768 ? 'none' : '1px solid #2196f3',
              borderRadius: window.innerWidth < 768 ? '0' : '8px',
              boxShadow: window.innerWidth < 768 ? 'none' : '0 2px 6px rgba(33, 150, 243, 0.2)',
              flexShrink: 0
            }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '32px', marginRight: '12px' }}>📊</span>
            <div>
              <h2 style={{
                margin: 0,
                fontSize: '20px',
                fontWeight: '600',
                color: '#1565c0'
              }}>
                All Documents
              </h2>
              <div style={{
                fontSize: '14px',
                color: '#1976d2',
                fontWeight: '500',
                marginTop: '2px'
              }}>
                Все документы • {documentsData.length} шт.
              </div>
            </div>
          </div>
          <button
              onClick={fetchDocumentsData}
              style={{
                padding: '4px 8px',
                background: 'rgba(255,255,255,0.8)',
                border: '1px solid #2196f3',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: '27px'
              }}
              title="Оновити список"
          >
              ⟲
          </button>
        </div>

        {/* Только таблица скроллится */}
        <div
            style={{
              flex: 1,
              minHeight: 0,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}
        >
          <DataTable
              data={documentsData}
              columns={columns}
              options={{
                showCheckboxes: false,
                showRowNumbers: false,
                striped: true,
                bordered: true,
                hoverable: true,
                sortable: true,
                filterable: true,
                emptyMessage: 'Немає документів',
                clickableRows: true,
                onRowClick: handleRowClick,
                selectedRow: selectedRowIndex
              }}
          />
        </div>        {/* Окно товаров */}
        {showProductsWindow && selectedDocumentForProducts && (
            <WindowProducts
                isOpen={showProductsWindow}
                document={selectedDocumentForProducts}
                positions={(selectedDocumentForProducts.Позиции || []).map(pos => {
                  // Если документ обработан, позиции уже в правильном формате
                  if (selectedDocumentForProducts.isProcessed) {
                    return {
                      // Обработанные данные уже в формате 1С
                      Код: pos.Код || '',
                      Наименование: pos.Наименование || '',
                      Штрихкод: pos.Штрихкод || '',
                      КоличествоПлан: Number(pos.КоличествоПлан) || 0,
                      КоличествоФакт: Number(pos.КоличествоФакт) || 0,
                      КоличествоРезерв: Number(pos.КоличествоРезерв) || 0,
                      Категория: pos.Категория || '',
                      Подкатегория: pos.Подкатегория || '',
                      ТорговаяМарка: pos.ТорговаяМарка || '',
                      Склад: pos.Склад || '',
                      СтатусПозиции: pos.СтатусПозиции || '',
                      // Дублируем для совместимости с WindowProducts
                      article: pos.Код || '',
                      name: pos.Наименование || '',
                      barcode: pos.Штрихкод || '',
                      plan: Number(pos.КоличествоПлан) || 0,
                      fact: Number(pos.КоличествоФакт) || 0,
                      reserve: Number(pos.КоличествоРезерв) || 0,
                      category: pos.Категория || '',
                      subcategory: pos.Подкатегория || '',
                      brand: pos.ТорговаяМарка || '',
                      warehouse: pos.Склад || '',
                      status: pos.СтатусПозиции || ''
                    };
                  } else {
                    // Если документ не обработан, используем исходные данные
                    return {
                      Код: pos.Код || '',
                      Наименование: pos.Наименование || '',
                      Штрихкод: pos.Штрихкод || '',
                      КоличествоПлан: Number(pos.КоличествоПлан) || 0,
                      КоличествоФакт: Number(pos.КоличествоФакт) || 0,
                      // Дублируем для совместимости с WindowProducts
                      article: pos.Код || '',
                      name: pos.Наименование || '',
                      barcode: pos.Штрихкод || '',
                      plan: Number(pos.КоличествоПлан) || 0,
                      fact: Number(pos.КоличествоФакт) || 0
                    };
                  }
                })}
                onClose={handleCloseProductsWindow}
                onOpenPrint={handleOpenPrint}
            />
        )}

        {/* Окно печати */}
        {showPrintWindow && (
            <WindowPrint
                onClose={handleClosePrintWindow}
                documentData={printDocument}
                positions={printPositions}
            />
        )}
      </div>
  );
}
